const styles = () => ({
  formLabelRoot: {
    color: 'rgb(89, 97, 104)',
    fontSize: 15,
    fontWeight: 'normal',
    margin: 0,
  },

  // This needs to be here so we can override without a warning.
  inputRoot: {},
});

export default styles;
